module.exports = __webpack_public_path__ + "static/media/check.6f7a8d9c.svg";